
export const ErrorState = () => {
  return (
    <div className="text-center text-destructive">
      Failed to load funds. Please try again later.
    </div>
  );
};
